import React from 'react'
import { Box, Container, SxProps } from '@mui/material'
import PropTypes from 'prop-types'
import useSettings from '../../hooks/useSettings'

interface PageContainerProps {
  children: React.ReactNode
  sx?: SxProps
}

const PageContainer = ({ children, sx }: PageContainerProps) => {
  const { settings } = useSettings()
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
    >
      <Container
        sx={theme => ({
          paddingX: '0',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          [theme.breakpoints.up('md')]: {
            paddingX: '0',
            maxWidth: '100%',
          },
          [theme.breakpoints.up('lg')]: {
            paddingX: '0',
            maxWidth: '100%',
          },
          [theme.breakpoints.up('xl')]: {
            paddingX: '0',
            maxWidth: '100%',
          },
        })}
        maxWidth={settings.compact && 'xl'}
      >
        {children}
      </Container>
    </Box>
  )
}

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PageContainer
